import { registerComponent, debounce } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "sale-toggle",
  class SaleToggle extends WYATTElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="checkbox"]');

      this.input.addEventListener(
        "change",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    onChange(event) {
      this.publish(WYATT.PubSub.events.saleToggleChange, {
        ref: this,
        showOnSaleOnly: event.target.checked,
      });
    }
  },
);
